import React from "react";
import "./style.scss";

export default function Education({ education = {} }) {
  const { GraduateSchool, EducationRank, Certificate, Major } = education;
  return (
    <React.Fragment>
      <div className="form-readonly ma-2">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Education Rank</div>
            <div className="form-value">
              <span>{EducationRank}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Graduate School</div>
            <div className="form-value">
              <span>{GraduateSchool}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Certificate</div>
            <div className="form-value">
              <span>{Certificate}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Major</div>
            <div className="form-value">
              <span>{Major}</span>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
